// extracted by mini-css-extract-plugin
export default {"city":"display_city__oDKQ0"};